import Pill from '../../pill'

const ResolutionMajority = (props) => {
  const record = props.record
  if (record.majorite_bo == 'sans vote') return null
  return (
    <Pill
      id={`majority${record.id}`}
      value={record.majorite_bo.toUpperCase()}
      status="light"
    />
  )
}
export default ResolutionMajority
